import React from 'react';
import { ArrowsContainer, LeftArrow, RightArrow, ScreenContainer, ScreenSwapContainer } from './ScreenAssetSwap.styles';
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import VideoPlayer from 'src/elements/video/VideoPlayer/VideoPlayer';
import ArrowWithCircle from 'src/images/2024_Q1_people_magic/ArrowWithCircle';

interface ScreenAssetSwapProps {
  screens: {
    image?: IGatsbyImageData;
    mobileImage?: IGatsbyImageData;
    videoUrl?: string;
    posterUrl?: string;
    videoMobileUrl?: string;
    posterMobileUrl?: string;
    active?: boolean;
  }[];
  onClickLeftArrow: () => void;
  onClickRightArrow: () => void;
}

const ScreenAssetSwap = ({ screens, onClickLeftArrow, onClickRightArrow }: ScreenAssetSwapProps): JSX.Element => {
  return (
    <ScreenSwapContainer>
      {screens.map((screen, index) => (
        <ScreenContainer
          key={index}
          active={screen.active}
        >
          {screen.image && (
            <GatsbyImage
              image={screen.image}
              className='desktop-image'
              alt=''
            />
          )}
          {screen.mobileImage && (
            <GatsbyImage
              image={screen.mobileImage}
              className='mobile-image'
              alt=''
            />
          )}
          {screen.videoUrl && (
            <VideoPlayer
              className='desktop-video-player'
              src={!screen.active ? '' : screen.videoUrl}
              poster={screen.posterUrl}
              autoPlay
              muted
              loop
              playsInline
              videoLabel=''
            />
          )}
          {screen.videoMobileUrl && (
            <VideoPlayer
              className='mobile-video-player'
              src={!screen.active ? '' : screen.videoMobileUrl}
              poster={screen.posterMobileUrl}
              autoPlay
              muted
              loop
              playsInline
              videoLabel=''
            />
          )}
        </ScreenContainer>
      ))}
      <ArrowsContainer>
        <LeftArrow onClick={onClickLeftArrow}>
          <ArrowWithCircle />
        </LeftArrow>
        <RightArrow onClick={onClickRightArrow}>
          <ArrowWithCircle />
        </RightArrow>
      </ArrowsContainer>
    </ScreenSwapContainer>
  );
};

export default ScreenAssetSwap;
